import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { baseUrl } from "../../../resources/Constants";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import ModalHistoriaGeneral from "./ModalHistoriaGeneral";
// COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
// import ModalHistoriaClinica from "./ModalHistoriaClinica";
import ModalExamenes from "./ModalExamenes";
import ModalFormulas from "./ModalFormulas";
import ModalIncapacidades from "./ModalIncapacidades";
import ModalRecomendaciones from "./ModalRecomendaciones";
import ModalVerHistoriaGeneral from "./ModalVerHistoriaGeneral";
import ModalRemisiones from "./ModalRemisiones";
import ModalContraremisiones from "./ModalContraremisiones";
import ModalConsentimientos from "./ModalConsentimientos";
import ModalPlantillas from "./ModalPlantillas";
import ModalOdontograma from "./ModalOdontograma";

import RegistroRipsSinFev from "../rips/RegistroRipsSinFev";
import RegistroRipsFev from "../rips/RegistroRipsFev";
import RegistroRipsConvenio from "../rips/RegistroRipsConvenio";
import { Modal, Button } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { tiposDocumento, sexoBiologico, discapacidades, etnias, identidadesGenero } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";

function AtenderPaciente2() {

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');

    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [genero, setGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [ciudadNacimiento, setCiudadNacimiento] = useState('');
    const [edad, setEdad] = useState('');
    const [ocupacion, setOcupacion] = useState('');
    const [nacionalidad, setNacionalidad] = useState('');
    const [estadoPaciente, setEstadoPaciente] = useState('');
    const [direccion, setDireccion] = useState('');
    const [pais, setPais] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [paisResidencia, setPaisResidencia] = useState('');
    const [vinculacion, setVinculacion] = useState('');
    const [eps, setEps] = useState('');
    const [nombreEps, setNombreEps] = useState('');
    const [clasificacion, setClasificacion] = useState('');
    const [convenio, setConvenio] = useState('');
    const [medioPublicitario, setMedioPublicitario] = useState('');
    const [referido, setReferido] = useState('');
    const [nombreResponsable, setNombreResponsable] = useState('');
    const [telResponsable, setTelResponsable] = useState('');
    const [parentescoResponsable, setParentescoResponsable] = useState('');
    const [documentoAcompanante, setDocumentoAcompanante] = useState('');
    const [emailAcompanante, setEmailAcompanante] = useState('');
    const [nombreMadre, setNombreMadre] = useState('');
    const [documentoMadre, setDocumentoMadre] = useState('');
    const [telefonoMadre, setTelefonoMadre] = useState('');
    const [ocupacionMadre, setOcupacionMadre] = useState('');
    const [nombrePadre, setNombrePadre] = useState('');
    const [documentoPadre, setDocumentoPadre] = useState('');
    const [telefonoPadre, setTelefonoPadre] = useState('');
    const [ocupacionPadre, setOcupacionPadre] = useState('');
    const [clasificacionRiesgo, setClasificacionRiesgo] = useState('');
    const [descripcionClasificacion, setDescripcionClasificacion] = useState('');
    const [etnia, setEtnia] = useState('');
    const [horaNacimiento, setHoraNacimiento] = useState('');
    const [identidadGenero, setIdentidadGenero] = useState('');
    const [discapacidad, setDiscapacidad] = useState('');
    const [profesionalAsignado, setProfesionalAsignado] = useState('');

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [aseguradoras, setAseguradoras] = useState([]);
    const [convenios, setConvenios] = useState([]);
    const [mediosPublicitarios, setMediosPublicitarios] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));
    const [idCita, setIdCita] = useState(new URLSearchParams(queryParams).get('ct'));

    const [idPaisNacimiento, setIdPaisNacimiento] = useState();
    const [idCiudadNacimiento, setIdCiudadNacimiento] = useState();
    const [idCiudad, setIdCiudad] = useState();
    const [idNacionalidad, setIdNacionalidad] = useState();
    const [idPaisResidencia, setIdPaisResidencia] = useState();

    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [enfermedadActual, setEnfermedadActual] = useState('');
    const [revisionSistemas, setRevisionSistemas] = useState('');
    const [antecedentes, setAntecedentes] = useState('');
    const [examenFisico, setExamenFisico] = useState('');
    const [diagnostico, setDiagnostico] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [emailProfesional, setEmailProfesional] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [perfilimg, setPerfilimg] = useState('/dist/img/user-default.jpg');
    const logoImg = '/dist/img/logo-2.png';

    const [historiasGenerales, setHistoriasGenerales] = useState([]);
    const [historiaGeneral, setHistoriaGeneral] = useState([]);
    const [errorlist, setErrorlist] = useState({});
    const [estadosCita, setEstadosCita] = useState([]);
    const [estiloInfoMenores, setEstiloInfoMenores] = useState({});

    let history = useHistory();
    let userdata = [];

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);

    // Estados para controlar acordeones
    const [acordeonInfoPaciente, setAcordeonInfoPaciente] = useState(false);
    const [acordeonAtencion, setAcordeonAtencion] = useState(false);
    const [acordeonHistoria, setAcordeonHistoria] = useState(false);

    // Obtiene las historias clínicas (general) del paciente
    const getHistorias = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso a historias (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }
        const parametrosHistorias = { id: paciente_id };

        if (esProfesionalIndependiente) {
            parametrosHistorias.validar_asignacion = true;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        const config2 = {
            params: parametrosHistorias
        }

        axios.get('/historias-paciente', config2)
            .then(response => {
                setHistoriasGenerales(response.data);
            })
            .catch(error => {
                console.log('Error cargando historias:', error);

                // 🆕 PROFESIONAL INDEPENDIENTE - Manejar error de acceso denegado
                if (error.response && error.response.status === 403) {
                    console.log('Acceso denegado a historias del paciente');
                    setHistoriasGenerales([]);
                }
            })
    }


    // Cuando se renderiza el componente, se cargan maestros e info relacionada (perfil del profesional, estados-cita, info del paciente)
    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso para atender pacientes (con fallback)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'atenderPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('atenderPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // 🆕 PARAMETRIZACIÓN FACTURADOR - Verificar si el usuario es facturador
        // 0 = Sí es facturador (muestra RIPS FEV y Convenio)
        // 1 = No es facturador (muestra RIPS Sin FEV)
        const facturadorValue = userdata.facturador !== undefined ? userdata.facturador : 0;
        setEsFacturador(facturadorValue === 0);
        console.log('Usuario es facturador:', facturadorValue === 0);

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso al paciente (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        // ✅ Usar axios en lugar de fetch - ya tiene el interceptor configurado
        let requestPerfil = axios.get('/perfil');

        let requestEstadosCita = axios.get('/estados-cita', {
            params: { mostrar_atencion: 1 }
        });

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        const parametrosPaciente = { id: paciente_id };
        if (esProfesionalIndependiente) {
            parametrosPaciente.validar_asignacion = true;
            console.log('Profesional Independiente - Validando acceso al paciente');
        }

        let requestPaciente = axios.get('/paciente', {
            params: parametrosPaciente
        });

        let result = Promise.all([requestPerfil, requestEstadosCita, requestPaciente]);

        result.then(
            function (response) {
                console.log('Respuestas recibidas:', response);

                // asigna información del profesional que atiende
                if (response[0] && response[0].data) {
                    setNombreProfesional(response[0].data.name + ' ' + response[0].data.lastname);
                    setEmailProfesional(response[0].data.email);
                    setEspecialidad(response[0].data.especialidad);
                    setRegistroMedico(response[0].data.registro_medico);
                    setCodigoHabilitacion(response[0].data.codigo_habilitacion);
                    setFirmaimg(response[0].data.firma);
                }

                // asigna los estados de cita del cliente
                if (response[1] && response[1].data) {
                    setEstadosCita(response[1].data);
                }

                // asigna la info del paciente
                if (response[2] && response[2].data) {
                    console.log('Datos del paciente:', response[2].data);
                    asignarInfoPaciente(response[2].data);
                }
            }
        ).catch(error => {
            console.error('Error al cargar datos:', error);

            // 🆕 PROFESIONAL INDEPENDIENTE - Manejar error de acceso denegado
            if (error.response && error.response.status === 403) {
                alert('No tienes acceso a este paciente. Solo puedes atender pacientes asignados a ti.');
                history.push('/pacientes');
                return;
            }

            alert('Error al cargar los datos del paciente. Por favor, recargue la página.');
        });

        getHistorias();
        cargarEvolucionesYHistorias(); // 🆕 Cargar datos para historia consolidada
    }, []);

    // Asigna la información del paciente a los campos correspondientes
    const asignarInfoPaciente = (response) => {

        // 🔒 VALIDACIÓN DE SEGURIDAD - Verificar que no sea una empresa
        if (response[0].tipo_cliente === 1) {
            alert('Este registro corresponde a una empresa, no a un paciente. No se puede atender como paciente médico.');
            history.push('/pacientes');
            return;
        }

        // 🔒 VALIDACIÓN ADICIONAL - Los pacientes deben tener tipo_cliente = 0 o null (legacy)
        if (response[0].tipo_cliente !== null && response[0].tipo_cliente !== 0 && response[0].tipo_cliente !== 1) {
            console.warn('Tipo de cliente no reconocido:', response[0].tipo_cliente);
        }

        setPrimerNombre(response[0].primer_nombre || '');
        setSegundoNombre(response[0].segundo_nombre || '');
        setPrimerApellido(response[0].primer_apellido || '');
        setSegundoApellido(response[0].segundo_apellido || '');
        setNumeroDocumento(response[0].numero_documento || '');
        setTipoDocumento(response[0].tipo_documento || '');
        setEmail(response[0].email || '');
        setCelular(response[0].celular || '');
        setGenero(response[0].sexo || '');
        setTipoSangre(response[0].rh || '');
        setEstadoCivil(response[0].estado_civil || '');
        setFechaNacimiento(response[0].fecha_nacimiento || '');
        setCiudadNacimiento(response[0].ciudad_nacimiento || '');
        setOcupacion(response[0].ocupacion || '');
        setNacionalidad(response[0].nacionalidad || '');
        setDireccion(response[0].direccion || '');
        setCiudad(response[0].ciudad || '');
        setZona(response[0].zona || '');
        setTelefono(response[0].telefono || '');
        setVinculacion(response[0].vinculacion || '');
        setEps(response[0].eps || '');
        setNombreEps(response[0].nombre_eps || '');
        setClasificacionRiesgo(response[0].clasificacion_riesgo || '');
        setDescripcionClasificacion(response[0].descripcion_clasificacion || '');
        setMedioPublicitario(response[0].nombre_medio || '');
        setReferido(response[0].referido_por || '');
        setNombreResponsable(response[0].nombre_acompanante || '');
        setTelResponsable(response[0].telefono_acompanante || '');
        setDocumentoAcompanante(response[0].doc_acompanante || '');
        setEmailAcompanante(response[0].email_acompanante || '');
        setParentescoResponsable(response[0].parentesco_acompanante || '');
        setNombreMadre(response[0].nombre_madre || '');
        setDocumentoMadre(response[0].documento_madre || '');
        setTelefonoMadre(response[0].telefono_madre || '');
        setOcupacionMadre(response[0].ocupacion_madre || '');
        setNombrePadre(response[0].nombre_padre || '');
        setDocumentoPadre(response[0].documento_padre || '');
        setTelefonoPadre(response[0].telefono_padre || '');
        setOcupacionPadre(response[0].ocupacion_padre || '');
        setEstadoPaciente(response[0].estado || '');
        setConvenio(response[0].nombre_convenio || '');

        setPaisNacimiento(response[0].nombre_pais_nacimiento || '');
        setIdPaisNacimiento(response[0].id_pais_nacimiento || '');

        setIdCiudadNacimiento(response[0].id_ciudad_nacimiento || '');
        setCiudadNacimiento(response[0].nombre_ciudad_nacimiento || '');

        setIdCiudad(response[0].id_ciudad_residencia || '');
        setCiudad(response[0].nombre_ciudad_residencia || '');

        setPaisResidencia(response[0].nombre_pais_residencia || '');
        setIdPaisResidencia(response[0].id_pais_residencia || '');

        setNacionalidad(response[0].nombre_pais_nacionalidad || '');
        setIdNacionalidad(response[0].id_pais_nacionalidad || '');

        let edadEnDias = parseInt(response[0].edad_paciente);

        if (edadEnDias > 365) {
            setEdad(Math.floor(edadEnDias / 365) + ' años');
            // Si el paciente es mayor de edad se oculta panel de información para menores de edad
            if (edadEnDias > 6570) {
                setEstiloInfoMenores({ display: 'none' });
            }
        }
        else if (edadEnDias < 30) {
            setEdad(edadEnDias + ' días');
        }
        else {
            setEdad(Math.floor(edadEnDias / 30) + ' meses');
        }

        if (response[0].imagen_perfil) {
            // El backend ya devuelve la URL completa con asset()
            setPerfilimg(response[0].imagen_perfil);
        }

        setEtnia(response[0].etnia);
        setIdentidadGenero(response[0].identidad_genero);
        setDiscapacidad(response[0].discapacidad);
        setProfesionalAsignado(response[0].nombre_profesional_asignado || '');
    }

    // Si la clasificación de riesgo es media o alta se muestra el popup de advertencia al profesional...
    useEffect(() => {
        if ((clasificacionRiesgo == 'medio' || clasificacionRiesgo == 'alto') && descripcionClasificacion) {
            setShow(true);
        }
    }, [clasificacionRiesgo, descripcionClasificacion]);

    // 🆕 Cargar parámetros de historia clínica para obtener el título
    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            const userdata = JSON.parse(localStorage.getItem('userdata'));

            axios.get('/parametros-historia-clinica', {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        setParametrosHistoriaClinica(response.data);

                        // Buscar parámetro con tipo_campo "titulo"
                        const parametroTitulo = response.data.find(param => param.tipo_campo === 'titulo');
                        if (parametroTitulo) {
                            setTituloHistoriaClinica(`Historia Clínica - ${parametroTitulo.nombre}`);
                        }
                    }
                })
                .catch(error => {
                    console.log('Error cargando parámetros historia clínica:', error);
                });
        }
    }, []);




    const motivoConsultaHandler = (event, editor) => {
        setMotivoConsulta(editor.getData());
    }
    const enfermedadHandler = (event, editor) => {
        setEnfermedadActual(editor.getData());
    }
    const revisionSistemasHandler = (event, editor) => {
        setRevisionSistemas(editor.getData());
    }
    const antecedentesHandler = (event, editor) => {
        setAntecedentes(editor.getData());
    }
    const examenFisicoHandler = (event, editor) => {
        setExamenFisico(editor.getData());
    }
    const diagnosticoHandler = (event, editor) => {
        setDiagnostico(editor.getData());
    }



    // Acción para cuando se guarda una historia clínica general
    const handleSubmit = (e) => {
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        const config = {
            paciente_id: pacienteId,
            client_id: userdata.client_id,
            profesional: nombreProfesional,
            firma: firmaimg,
            motivo_consulta: segundoApellido,
            enfermedad_actual: numeroDocumento,
            revision_sistemas: tipoDocumento,
            antecedentes: email,
            examen_fisico: celular,
            diagnostico: genero
        }

        axios.post('/historia-general', config)
            .then(response => {
                setLoading(false);
                history.push('/pacientes');
            })
            .catch(error => {
                setErrorlist(error.response.data.errors);
            })
    }

    const actualizarHistorias = () => {
        getHistorias();
        setToastMsg('La historia clínica ha sido guardada');
    }


    const [historia, setHistoria] = useState({});
    const [verMotivoConsulta, setVerMotivoConsulta] = useState('');
    const [verEnfermedadActual, setVerEnfermedadActual] = useState('');
    const [verRevisionSistemas, setVerRevisionSistemas] = useState('');
    const [verAntecedentes, setVerAntecedentes] = useState('');
    const [verAntecedentesFamiliares, setVerAntecedentesFamiliares] = useState('');
    const [verExamen, setVerExamen] = useState('');
    const [verExamenesComplementarios, setVerExamenesComplementarios] = useState('');
    const [verDiagnostico, setVerDiagnostico] = useState('');
    const [verPlanTratamiento, setVerPlanTratamiento] = useState('');


    // Obtiene la info de una historia clínica en particular
    const consultarHistoria = (idHistoria) => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso a historia específica (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }
        const parametrosHistoria = { id: idHistoria };

        if (esProfesionalIndependiente) {
            parametrosHistoria.validar_asignacion = true;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        const config = {
            params: parametrosHistoria
        }

        axios.get('historia-general', config)
            .then(response => {
                setHistoriaGeneral(response.data[0]);
            })
            .catch(error => {
                console.log('Error consultando historia:', error);

                // 🆕 PROFESIONAL INDEPENDIENTE - Manejar error de acceso denegado
                if (error.response && error.response.status === 403) {
                    alert('No tienes acceso a esta historia clínica.');
                }
            })
    }


    // Debido a que los campos de la historia clínica guardan la info en formato html, esta información se debe renderizar como tal...
    function createMarkup(arg) {
        return {
            __html: arg
        };
    };

    // Cambia el estado de la cita (al hacer clic en alguno de los botones del último panel)
    function cambiarEstadoCita(idCita, nuevoEstadoCita, nombreEstado) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        const config = {
            id: idCita,
            estado_cita: nuevoEstadoCita,
        }

        axios.put('editar-estado-cita', config)
            .then(response => {
                // Volver a agenda
                localStorage.setItem('cita_atendida', JSON.stringify({ id: idCita, estado: nombreEstado, id_paciente: paciente_id }));

                const proximaCita = {
                    id_profesional: userdata.user_id,
                    nombre_profesional: userdata.user_name + ' ' + userdata.user_lastname,
                    primer_nombre: primerNombre,
                    segundo_nombre: segundoNombre,
                    primer_apellido: primerApellido,
                    segundo_apellido: segundoApellido,
                    numero_documento: numeroDocumento,
                    tipo_documento: tipoDocumento,
                    email: email,
                    celular: celular,
                    id_paciente: pacienteId
                };

                localStorage.setItem('proximaCita', JSON.stringify(proximaCita));
                history.push('/home');
            })
            .catch(error => {
                console.log(error);
            });
    }


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    // 🆕 Estados para dropdowns de atención médica
    const [showDropdownHistoriaClinica, setShowDropdownHistoriaClinica] = useState(false);
    const [showDropdownRips, setShowDropdownRips] = useState(false);
    const [showDropdownDocumentos, setShowDropdownDocumentos] = useState(false);
    const [showDropdownGraficos, setShowDropdownGraficos] = useState(false);

    const [showEvolucion, setShowEvolucion] = useState(false);
    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // const [showHistoriaClinica, setShowHistoriaClinica] = useState(false);
    const [showExamenes, setShowExamenes] = useState(false);
    const [showFormulas, setShowFormulas] = useState(false);
    const [showIncapacidades, setShowIncapacidades] = useState(false);
    const [showRecomendaciones, setShowRecomendaciones] = useState(false);
    const [showRemisiones, setShowRemisiones] = useState(false);
    const [showContraremisiones, setShowContraremisiones] = useState(false);
    const [showConsentimientos, setShowConsentimientos] = useState(false);
    const [showPlantillas, setShowPlantillas] = useState(false);
    const [showRipsSinFev, setShowRipsSinFev] = useState(false);
    const [showRipsFev, setShowRipsFev] = useState(false);
    const [showRipsConvenio, setShowRipsConvenio] = useState(false);
    const [showOdontograma, setShowOdontograma] = useState(false);

    // 🆕 Estado para controlar si el usuario es facturador
    const [esFacturador, setEsFacturador] = useState(false);


    // 🆕 Estado para parámetros de historia clínica
    const [parametrosHistoriaClinica, setParametrosHistoriaClinica] = useState([]);
    const [tituloHistoriaClinica, setTituloHistoriaClinica] = useState('Historia Clínica');

    // 🆕 Función para cerrar todos los acordeones al abrir un modal
    const cerrarTodosAcordeones = () => {
        setAcordeonInfoPaciente(false);
        setAcordeonAtencion(false);
        setAcordeonHistoria(false);
    };

    const [cargarHistorialEvolucion, setCargarHistorialEvolucion] = useState(false);
    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // const [cargarHistorialHistoriaClinica, setCargarHistorialHistoriaClinica] = useState(false);
    const [cargarHistorialExamenes, setCargarHistorialExamenes] = useState(false);
    const [cargarHistorialFormulas, setCargarHistorialFormulas] = useState(false);
    const [cargarHistorialIncapacidades, setCargarHistorialIncapacidades] = useState(false);
    const [cargarHistorialRecomendaciones, setCargarHistorialRecomendaciones] = useState(false);
    const [cargarHistorialRemisiones, setCargarHistorialRemisiones] = useState(false);
    const [cargarHistorialContraremisiones, setCargarHistorialContraremisiones] = useState(false);
    const [cargarHistorialConsentimientos, setCargarHistorialConsentimientos] = useState(false);
    const [cargarHistorialPlantillas, setCargarHistorialPlantillas] = useState(false);
    const [cargarHistorialRipsSinFev, setCargarHistorialRipsSinFev] = useState(false);
    const [cargarHistorialRipsFev, setCargarHistorialRipsFev] = useState(false);
    const [cargarHistorialRipsConvenio, setCargarHistorialRipsConvenio] = useState(false);

    // 🆕 Estados para el botón "Imprimir Historia"
    const [evoluciones, setEvoluciones] = useState([]);
    const [historiasClinicas, setHistoriasClinicas] = useState([]);
    const [historiasClinicasJson, setHistoriasClinicasJson] = useState([]); // 🆕 Historias JSON
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [showModalGenerandoPDF, setShowModalGenerandoPDF] = useState(false); // 🆕 Modal de carga PDF

    // 🆕 Función para cargar evoluciones y historias clínicas
    const cargarEvolucionesYHistorias = async () => {
        if (!localStorage.getItem('userdata')) return;

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const parametros = { id: paciente_id };
        if (esProfesionalIndependiente) {
            parametros.validar_asignacion = true;
        }

        const config = { params: parametros };

        try {
            // Cargar evoluciones
            const responseEvoluciones = await axios.get('/evoluciones', config);
            setEvoluciones(responseEvoluciones.data || []);

            // Cargar historias clínicas (sistema antiguo)
            const responseHistorias = await axios.get('/historia-clinica', config);
            setHistoriasClinicas(responseHistorias.data || []);

            // 🆕 Cargar historias clínicas JSON (sistema nuevo)
            const parametrosJson = { paciente_id: paciente_id };
            if (esProfesionalIndependiente) {
                parametrosJson.validar_asignacion = true;
            }
            const responseHistoriasJson = await axios.get('/historia-clinica-json', { params: parametrosJson });
            setHistoriasClinicasJson(responseHistoriasJson.data || []);

            // Cargar encabezado personalizado
            const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
            console.log('🔍 Respuesta encabezado personalizado:', responseEncabezado);
            if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                console.log('✅ Encabezado personalizado cargado:', responseEncabezado.data);
                setEncabezadoPersonalizado(responseEncabezado.data);
            } else {
                console.log('⚠️ Encabezado personalizado no disponible o deshabilitado');
            }
        } catch (error) {
            console.log('Error cargando datos para historia consolidada:', error);
            if (error.response && error.response.status === 403) {
                console.log('Acceso denegado a algunos registros del paciente');
            }
            // 🆕 Intentar cargar encabezado aunque fallen otros datos
            try {
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
                if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                    console.log('✅ Encabezado personalizado cargado en catch:', responseEncabezado.data);
                    setEncabezadoPersonalizado(responseEncabezado.data);
                }
            } catch (encabezadoError) {
                console.log('Error cargando encabezado personalizado:', encabezadoError);
            }
        }
    };

    function abrirEvolucion() {
        cerrarTodosAcordeones();
        history.push(`/evolucion-paciente?id=${paciente_id}`);
    }
    function cerrarEvolucion() {
        setShowEvolucion(false);
        setCargarHistorialEvolucion(false);
    }

    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // function abrirHistoriaClinica() {
    //     cerrarTodosAcordeones();
    //     setShowHistoriaClinica(true);
    //     setCargarHistorialHistoriaClinica(true);
    // }
    // function cerrarHistoriaClinica() {
    //     setShowHistoriaClinica(false);
    //     setCargarHistorialHistoriaClinica(false);
    // }

    function abrirHistoriaClinicaJson() {
        cerrarTodosAcordeones();
        history.push(`/historia-clinica-json?id=${pacienteId}`);
    }
    function cerrarHistoriaClinicaJson() {
        // Ya no es necesario, pero mantenemos por compatibilidad
    }


    function abrirExamenes() {
        cerrarTodosAcordeones();
        setShowExamenes(true);
        setCargarHistorialExamenes(true);
    }
    function cerrarExamenes() {
        setShowExamenes(false);
        setCargarHistorialExamenes(false);
    }


    function abrirFormulas() {
        cerrarTodosAcordeones();
        setShowFormulas(true);
        setCargarHistorialFormulas(true);
    }
    function cerrarFormulas() {
        setShowFormulas(false);
        setCargarHistorialFormulas(false);
    }


    function abrirIncapacidades() {
        cerrarTodosAcordeones();
        setShowIncapacidades(true);
        setCargarHistorialIncapacidades(true);
    }
    function cerrarIncapacidades() {
        setShowIncapacidades(false);
        setCargarHistorialIncapacidades(false);
    }


    function abrirRecomendaciones() {
        cerrarTodosAcordeones();
        setShowRecomendaciones(true);
        setCargarHistorialRecomendaciones(true);
    }
    function cerrarRecomendaciones() {
        setShowRecomendaciones(false);
        setCargarHistorialRecomendaciones(false);
    }


    function abrirRemisiones() {
        cerrarTodosAcordeones();
        setShowRemisiones(true);
        setCargarHistorialRemisiones(true);
    }
    function cerrarRemisiones() {
        setShowRemisiones(false);
        setCargarHistorialRemisiones(false);
    }


    function abrirContraremisiones() {
        cerrarTodosAcordeones();
        setShowContraremisiones(true);
        setCargarHistorialContraremisiones(true);
    }
    function cerrarContraremisiones() {
        setShowContraremisiones(false);
        setCargarHistorialContraremisiones(false);
    }


    function abrirConsentimientos() {
        cerrarTodosAcordeones();
        setShowConsentimientos(true);
        setCargarHistorialConsentimientos(true);
    }
    function cerrarConsentimientos() {
        setShowConsentimientos(false);
        setCargarHistorialConsentimientos(false);
    }


    function abrirPlantillas() {
        cerrarTodosAcordeones();
        setShowPlantillas(true);
        setCargarHistorialPlantillas(true);
    }
    function cerrarPlantillas() {
        setShowPlantillas(false);
        setCargarHistorialPlantillas(false);
    }

    function abrirRipsFev() {
        cerrarTodosAcordeones();
        setShowRipsFev(true);
        setCargarHistorialRipsFev(true);
    }
    function cerrarRipsFev() {
        setShowRipsFev(false);
        setCargarHistorialRipsFev(false);
    }

    function abrirRipsSinFev() {
        cerrarTodosAcordeones();
        setShowRipsSinFev(true);
        setCargarHistorialRipsSinFev(true);
    }
    function cerrarRipsSinFev() {
        setShowRipsSinFev(false);
        setCargarHistorialRipsSinFev(false);
    }

    function abrirRipsConvenio() {
        cerrarTodosAcordeones();
        setShowRipsConvenio(true);
        setCargarHistorialRipsConvenio(true);
    }
    function cerrarRipsConvenio() {
        setShowRipsConvenio(false);
        setCargarHistorialRipsConvenio(false);
    }

    function abrirOdontograma() {
        cerrarTodosAcordeones();
        setShowOdontograma(true);
    }

    function cerrarOdontograma() {
        setShowOdontograma(false);
    }

    function abrirToxina() {
        cerrarTodosAcordeones();
        // Navegar a página completa en lugar de modal
        history.push(`/toxina-botulinica?id=${paciente_id}`);
    }




    function guardarCambios(msg) {
        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) }, 800);
    }


    function seccionEstadosCita(idcita) {
        if (idcita) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <a className="d-block w-100">
                                        Estado de la Cita
                                    </a>
                                </h4>
                            </div>
                            <div className="card-body">

                                {
                                    estadosCita.map((estadoCita) =>
                                        <button className="btn btn-primary" style={{ marginRight: '8px' }} onClick={() => cambiarEstadoCita(idcita, estadoCita.id, estadoCita.nombre)}>{estadoCita.nombre}</button>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    const getInfoAnamnesisPDF = () => {
        try {
            let contenidoInfoGeneral = '';
            let contenidoPaciente = '';

            const elementoInfoGeneral = document.getElementById('panel-info-general');
            const elementoInfoPaciente = document.getElementById('panel-info-paciente');

            if (elementoInfoGeneral) {
                contenidoInfoGeneral = elementoInfoGeneral.innerHTML;
            }

            if (elementoInfoPaciente) {
                contenidoPaciente = elementoInfoPaciente.innerHTML;
            }

            return '<div className="contenedor-pdf">' + contenidoInfoGeneral + contenidoPaciente + '</div>';
        } catch (error) {
            console.error('Error al obtener información para PDF:', error);
            return '<div className="contenedor-pdf"><p>Error al cargar información del paciente</p></div>';
        }
    }

    const getHistoriasPDF = () => {

        let historiasPDF = "";

        for (let hg of historiasGenerales) {

            let motivoConsulta = hg.motivo_consulta ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Motivo de consulta:</label>' +
                '<div class="form-group">' +
                hg.motivo_consulta +
                '</div>' +
                '</div>' : '';


            let enfermedadActual = hg.enfermedad_actual ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Enfermedad Actual:</label>' +
                '<div class="form-group">' +
                hg.enfermedad_actual +
                '</div>' +
                '</div>' : '';

            let revisionSistemas = hg.revision_sistemas ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Revisión por Sistemas:</label>' +
                '<div class="form-group">' +
                hg.revision_sistemas +
                '</div>' +
                '</div>' : '';

            let antecedentes = hg.antecedentes ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Antecedentes Personales:</label>' +
                '<div class="form-group">' +
                hg.antecedentes +
                '</div>' +
                '</div>' : '';

            let antecedentesFamiliares = hg.antecedentes_familiares ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Antecedentes Familiares:</label>' +
                '<div class="form-group">' +
                hg.antecedentes_familiares +
                '</div>' +
                '</div>' : '';

            let examenFisico = hg.examen_fisico ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Examen Físico:</label>' +
                '<div class="form-group">' +
                hg.examen_fisico +
                '</div>' +
                '</div>' : '';

            let examenesComplementarios = hg.examenes_complementarios ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Examenes Complementarios:</label>' +
                '<div class="form-group">' +
                hg.examenes_complementarios +
                '</div>' +
                '</div>' : '';

            let diagnostico = hg.diagnostico ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Diagnóstico:</label>' +
                '<div class="form-group">' +
                hg.diagnostico +
                '</div>' +
                '</div>' : '';

            let planTratamiento = hg.plan_tratamiento ?
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Plan de Tratamiento:</label>' +
                '<div class="form-group">' +
                hg.plan_tratamiento +
                '</div>' +
                '</div>' : '';


            let historiaMarkup = '<div class="contenedor-pdf atencion-pdf" style="page-break-inside: avoid;">' +
                '<div id="historiageneral">' +
                '<div class="row" style="position:relative">' +
                '<div class="col-md-12 dato-fila-pdf">' +
                '<h2 class="subttl-pdf">Consulta:</h2>' +
                '</div>' +
                '<div class="col-md-12 dato-fila-pdf">' +
                '<label>Fecha de consulta:</label>' +
                '<div class="form-group">' +
                hg.fecha +
                '</div>' +
                '</div>' +
                motivoConsulta +
                enfermedadActual +
                revisionSistemas +
                antecedentes +
                antecedentesFamiliares +
                examenFisico +
                examenesComplementarios +
                diagnostico +
                planTratamiento +
                '</div>' +
                '</div>' +

                '<div class="dato-fila-pdf datos-profesional-pdf" id="profesional-atiende">' +
                '<div class="row">' +
                '<div class="col-md-3">' +
                '<div class="form-group">' +
                '<label htmlFor="nombreProfesional">Profesional que atendió:</label>' +
                '<br>' +
                hg.profesional +
                '</div>' +
                '</div>' +
                '<div class="col-md-3">' +
                '<div class="form-group">' +
                '<label htmlFor="nombreProfesional">Registro médico:</label>' +
                '<br>' +
                hg.registro_medico +
                '</div>' +
                '</div>' +
                '<div class="col-md-3">' +
                '<div class="form-group">' +
                '<label htmlFor="clasificacion_riesgo">Código de habilitación:</label>' +
                '<br>' +
                hg.codigo_habilitacion +
                '</div>' +
                '</div>' +
                '<div class="col-md-3">' +
                '<div class="form-group" style={{marginBottom: "0.4rem"}}>' +
                '<label htmlFor="nombreProfesional">Firma:</label>' +
                '<br>' +
                //'<img src="'+hg.firma+'" className="firma-profesional-hc" />'+
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            historiasPDF += historiaMarkup;
        }

        return historiasPDF;
    }

    const imprimirHistoria = () => {
        // Preparar datos del paciente
        const nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
        const documentoCompleto = `${tipoDocumento || ''} - ${numeroDocumento || ''}`;

        // Preparar secciones del documento
        const secciones = [];

        // 1. Título principal
        secciones.push({
            tipo: 'banner',
            contenido: 'HISTORIA CLÍNICA',
            estilos: {
                backgroundColor: '#325e68',
                textColor: '#ffffff',
                fontSize: 16,
                padding: 10
            }
        });

        // 2. Información de anamnesis (si existe)
        const infoAnamnesis = getInfoAnamnesisPDF();
        if (infoAnamnesis) {
            secciones.push({
                tipo: 'texto',
                contenido: infoAnamnesis
            });
        }

        // 3. Historias clínicas generales (si existen)
        const historiasHTML = getHistoriasPDF();
        if (historiasHTML) {
            secciones.push({
                tipo: 'salto-pagina'
            });
            
            secciones.push({
                tipo: 'texto',
                contenido: historiasHTML
            });
        }

        // Configuración del PDF
        const config = {
            filename: `hc-${numeroDocumento}.pdf`,
            paciente: {
                nombreCompleto: nombreCompleto,
                documentoCompleto: documentoCompleto
            },
            encabezadoPersonalizado: encabezadoPersonalizado ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            } : null,
            secciones: secciones,
            margenes: {
                top: 20,
                bottom: 20,
                left: 15,
                right: 15
            }
        };

        // Generar PDF con texto nativo
        const pdf = generarPdfConTextoNativo(config);

        // Descargar archivo
        pdf.save(config.filename);
    }

    // 🆕 Función para imprimir historia consolidada
    const imprimirHistoriaConsolidada = () => {
        // Mostrar modal de carga
        setShowModalGenerandoPDF(true);

        // Pequeño delay para que el modal se muestre antes de iniciar la generación
        setTimeout(() => {
            generarPDFHistoriaConsolidada();
        }, 300);
    };

    // 🆕 Función que genera el PDF (separada para mejor control del modal)
    // 🆕 Función que genera el PDF (separada para mejor control del modal)
    const generarPDFHistoriaConsolidada = async () => {
        try {
            console.log('📄 Iniciando generación de PDF consolidado');
            
            // 🆕 Cargar encabezado personalizado justo antes de generar el PDF
            let encabezadoParaPDF = encabezadoPersonalizado;
            
            if (!encabezadoParaPDF) {
                console.log('⚠️ Encabezado no disponible en estado, intentando cargar...');
                try {
                    const userdata = JSON.parse(localStorage.getItem('userdata'));
                    const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
                    if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                        console.log('✅ Encabezado personalizado cargado para PDF:', responseEncabezado.data);
                        encabezadoParaPDF = responseEncabezado.data;
                        // También actualizar el estado para futuras generaciones
                        setEncabezadoPersonalizado(responseEncabezado.data);
                    } else {
                        console.log('⚠️ Encabezado personalizado no disponible o deshabilitado');
                    }
                } catch (encabezadoError) {
                    console.log('❌ Error cargando encabezado personalizado:', encabezadoError);
                }
            } else {
                console.log('✅ Usando encabezado del estado');
            }
            
            console.log('🔍 Estado encabezadoPersonalizado:', encabezadoParaPDF);
            
            // Preparar datos del paciente
            const nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
            const documentoCompleto = `${tipoDocumento || ''} - ${numeroDocumento || ''}`;

            console.log('👤 Datos del paciente:', { nombreCompleto, documentoCompleto });
            console.log('📊 Datos disponibles:', {
                evoluciones: evoluciones?.length || 0,
                historiasClinicasJson: historiasClinicasJson?.length || 0,
                encabezadoPersonalizado: !!encabezadoParaPDF
            });

            // Preparar secciones del documento
            const secciones = [];

            // 1. Título principal
            secciones.push({
                tipo: 'banner',
                contenido: 'Historia Consolidada del Paciente',
                estilos: {
                    backgroundColor: '#325e68',
                    textColor: '#ffffff',
                    fontSize: 16,
                    padding: 10
                }
            });

            // 2. Información del Paciente - Datos Básicos
            secciones.push({
                tipo: 'titulo-seccion',
                contenido: 'Información del Paciente',
                estilos: {
                    fontSize: 14,
                    textColor: '#325e68',
                    negrita: true
                }
            });

            secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'Nombres y Apellidos', valor: nombreCompleto },
                        { etiqueta: 'Documento', valor: documentoCompleto },
                        { etiqueta: 'Edad', valor: edad || 'No registrada' },
                        { etiqueta: 'Sexo', valor: sexoBiologico[genero] || genero || 'No registrado' },
                        { etiqueta: 'Email', valor: email || 'No registrado' },
                        { etiqueta: 'Celular', valor: celular || 'No registrado' },
                        { etiqueta: 'Tipo de Sangre', valor: tipoSangre?.toUpperCase() || 'No registrado' },
                        { etiqueta: 'Estado Civil', valor: estadoCivil || 'No registrado' },
                        { etiqueta: 'Ocupación', valor: ocupacion || 'No registrada' },
                        { etiqueta: 'Clasificación de Riesgo', valor: clasificacionRiesgo?.toUpperCase() || 'No registrada' }
                    ]
                }
            });

            // Información de Domicilio
            secciones.push({
                tipo: 'subtitulo',
                contenido: 'Información de Domicilio',
                estilos: {
                    fontSize: 12,
                    textColor: '#325e68',
                    negrita: true
                }
            });

            secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'Dirección', valor: direccion || 'No registrada' },
                        { etiqueta: 'Ciudad', valor: ciudad || 'No registrada' },
                        { etiqueta: 'País', valor: paisResidencia || 'No registrado' },
                        { etiqueta: 'Teléfono', valor: telefono || 'No registrado' }
                    ]
                }
            });

            // Información de Salud
            secciones.push({
                tipo: 'subtitulo',
                contenido: 'Información de Salud',
                estilos: {
                    fontSize: 12,
                    textColor: '#325e68',
                    negrita: true
                }
            });

            const filasInfoSalud = [
                { etiqueta: 'EPS/Aseguradora', valor: nombreEps || 'No registrada' },
                { etiqueta: 'Vinculación', valor: vinculacion?.toUpperCase() || 'No registrada' },
                { etiqueta: 'Convenio', valor: convenio || 'No registrado' },
                { etiqueta: 'Discapacidad', valor: discapacidades[discapacidad] || 'Ninguna' }
            ];

            if (etnia) {
                filasInfoSalud.push({ etiqueta: 'Etnia', valor: etnias[etnia] || 'No registrada' });
            }
            if (identidadGenero) {
                filasInfoSalud.push({ etiqueta: 'Identidad de Género', valor: identidadesGenero[identidadGenero] || 'No registrada' });
            }

            secciones.push({
                tipo: 'tabla-datos',
                datos: { filas: filasInfoSalud }
            });

            // Profesional Asignado (si existe)
            if (profesionalAsignado) {
                secciones.push({
                    tipo: 'subtitulo',
                    contenido: 'Profesional Asignado',
                    estilos: {
                        fontSize: 12,
                        textColor: '#325e68',
                        negrita: true
                    }
                });

                secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'Profesional', valor: profesionalAsignado }
                        ]
                    }
                });
            }

            // Responsable/Acompañante (si existe)
            if (nombreResponsable || telResponsable || parentescoResponsable) {
                secciones.push({
                    tipo: 'subtitulo',
                    contenido: 'Responsable/Acompañante',
                    estilos: {
                        fontSize: 12,
                        textColor: '#325e68',
                        negrita: true
                    }
                });

                secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'Nombre', valor: nombreResponsable || 'No registrado' },
                            { etiqueta: 'Teléfono', valor: telResponsable || 'No registrado' },
                            { etiqueta: 'Parentesco', valor: parentescoResponsable || 'No registrado' },
                            { etiqueta: 'Documento', valor: documentoAcompanante || 'No registrado' }
                        ]
                    }
                });
            }

            // 3. EVOLUCIONES - Agregar cada evolución del historial
            if (evoluciones && evoluciones.length > 0) {
                // Banner de sección (sin salto de página forzado - dejar que la paginación automática lo maneje)
                secciones.push({
                    tipo: 'banner',
                    contenido: 'HISTORIAL DE EVOLUCIONES'
                });

                evoluciones.forEach((evol, index) => {
                    // Separador entre evoluciones (excepto la primera)
                    if (index > 0) {
                        secciones.push({
                            tipo: 'texto',
                            contenido: '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">'
                        });
                    }

                    // Datos de cabecera
                    const profesionalTratanteNombre = (evol.profesional_tratante_completo && 
                        evol.profesional_tratante_completo !== 'null' && 
                        evol.profesional_tratante_completo !== 'No registrado')
                        ? evol.profesional_tratante_completo
                        : 'No registrado';

                    secciones.push({
                        tipo: 'tabla-datos',
                        datos: {
                            filas: [
                                { etiqueta: 'FECHA', valor: evol.fecha },
                                { etiqueta: 'PROFESIONAL TRATANTE', valor: profesionalTratanteNombre }
                            ]
                        }
                    });

                    // Contenido personalizado
                    if (evol.contenido_personalizado) {
                        const contenidoHTML = renderizarContenidoPersonalizadoParaPDF(evol.contenido_personalizado);
                        if (contenidoHTML) {
                            secciones.push({
                                titulo: 'INFORMACIÓN ADICIONAL',
                                contenido: contenidoHTML,
                                tipo: 'texto'
                            });
                        }
                    }

                    // Eventos adversos
                    if (evol.eventos_adversos) {
                        secciones.push({
                            titulo: '⚠️ EVENTO ADVERSO',
                            contenido: evol.eventos_adversos,
                            tipo: 'texto'
                        });
                    }

                    // Plan de manejo
                    if (evol.plan_manejo_evento_adverso) {
                        secciones.push({
                            titulo: '📋 PLAN DE MANEJO',
                            contenido: evol.plan_manejo_evento_adverso,
                            tipo: 'texto'
                        });
                    }

                    // Firmas de esta evolución - AGRUPAR PARA MOSTRAR LADO A LADO
                    const firmasEvolucion = [];
                    
                    const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                        evol.profesional_tratante_completo !== 'null' &&
                        evol.profesional_tratante_completo !== 'No registrado');

                    const mostrarFirmaProfesional = tieneProfesionalRegistrado && evol.firma;

                    if (mostrarFirmaProfesional) {
                        firmasEvolucion.push({
                            imagenBase64: evol.firma,
                            metadata: {
                                tipo: 'profesional',
                                nombre: evol.profesional || '',
                                registroMedico: evol.registro_medico || 'N/A',
                                codigoHabilitacion: evol.codigo_habilitacion || 'N/A'
                            }
                        });
                    }

                    if (evol.firma_paciente) {
                        firmasEvolucion.push({
                            imagenBase64: evol.firma_paciente,
                            metadata: {
                                tipo: 'paciente'
                            }
                        });
                    }
                    
                    // Agregar firmas como grupo si hay alguna
                    if (firmasEvolucion.length > 0) {
                        secciones.push({
                            tipo: 'firmas-grupo',
                            firmas: firmasEvolucion
                        });
                    }
                });
            }

            // 4. HISTORIAS CLÍNICAS JSON - Agregar cada historia del sistema nuevo
            if (historiasClinicasJson && historiasClinicasJson.length > 0) {
                // Banner de sección (sin salto de página forzado - dejar que la paginación automática lo maneje)
                secciones.push({
                    tipo: 'banner',
                    contenido: 'HISTORIAS CLÍNICAS'
                });

                historiasClinicasJson.forEach((historia, index) => {
                    // Separador entre historias (excepto la primera)
                    if (index > 0) {
                        secciones.push({
                            tipo: 'texto',
                            contenido: '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">'
                        });
                    }

                    // Nombre de la plantilla como banner
                    const nombrePlantilla = historia.plantilla_nombre || 'Historia Clínica';
                    secciones.push({
                        tipo: 'banner',
                        contenido: nombrePlantilla.toUpperCase()
                    });

                    // Tabla de fecha
                    secciones.push({
                        tipo: 'tabla-datos',
                        datos: {
                            filas: [
                                { etiqueta: 'FECHA Y HORA', valor: new Date(historia.fecha).toLocaleString() }
                            ]
                        }
                    });

                    // Procesar datos de la historia (secciones con tablas)
                    try {
                        const datos = typeof historia.datos === 'string' 
                            ? JSON.parse(historia.datos) 
                            : historia.datos;
                        const estructura = typeof historia.plantilla_estructura === 'string' 
                            ? JSON.parse(historia.plantilla_estructura) 
                            : historia.plantilla_estructura;
                        
                        if (estructura && estructura.secciones && Array.isArray(estructura.secciones)) {
                            estructura.secciones.forEach(seccion => {
                                // Verificar si la sección tiene campos con valores
                                const filasSeccion = [];
                                
                                if (seccion.campos && Array.isArray(seccion.campos)) {
                                    seccion.campos.forEach(campo => {
                                        const valor = datos[campo.id];
                                        if (valor !== undefined && valor !== null && valor !== '') {
                                            // Formatear valor según tipo de campo
                                            let valorFormateado = valor;
                                            if (campo.tipo === 'checkbox') {
                                                valorFormateado = valor ? 'Sí' : 'No';
                                            } else if (campo.tipo === 'textarea') {
                                                valorFormateado = valor.replace(/\n/g, '<br>');
                                            }
                                            
                                            filasSeccion.push({
                                                etiqueta: campo.label,
                                                valor: valorFormateado
                                            });
                                        }
                                    });
                                }
                                
                                // Solo agregar sección si tiene contenido
                                if (filasSeccion.length > 0) {
                                    // Agregar título de sección como banner
                                    secciones.push({
                                        titulo: seccion.titulo,
                                        tipo: 'banner',
                                        contenido: seccion.titulo
                                    });
                                    
                                    // Agregar datos de la sección
                                    secciones.push({
                                        tipo: 'tabla-datos',
                                        datos: {
                                            filas: filasSeccion
                                        }
                                    });
                                }
                            });
                        }
                    } catch (error) {
                        console.error('Error parseando datos de historia:', error);
                    }

                    // Firmas lado a lado usando tipo 'firmas-grupo'
                    const firmasGrupo = [];
                    
                    // Firma del profesional
                    if (historia.profesional && historia.firma) {
                        firmasGrupo.push({
                            imagenBase64: historia.firma,
                            metadata: {
                                tipo: 'profesional',
                                nombre: historia.profesional || '',
                                registroMedico: historia.registro_medico || 'N/A',
                                codigoHabilitacion: historia.codigo_habilitacion || 'N/A'
                            }
                        });
                    }
                    
                    // Firma del paciente
                    if (historia.firma_paciente) {
                        firmasGrupo.push({
                            imagenBase64: historia.firma_paciente,
                            metadata: {
                                tipo: 'paciente'
                            }
                        });
                    }
                    
                    // Agregar firmas como grupo si hay alguna
                    if (firmasGrupo.length > 0) {
                        secciones.push({
                            tipo: 'firmas-grupo',
                            firmas: firmasGrupo
                        });
                    }
                });
            }

            // Configuración del PDF
            const config = {
                filename: `historia-consolidada-${numeroDocumento}.pdf`,
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoParaPDF ? {
                    izquierda: encabezadoParaPDF.izquierda || '',
                    centro: encabezadoParaPDF.centro || '',
                    derecha: encabezadoParaPDF.derecha || ''
                } : null,
                secciones: secciones,
                margenes: {
                    top: 20,
                    bottom: 20,
                    left: 15,
                    right: 15
                }
            };

            console.log('⚙️ Configuración del PDF:', {
                filename: config.filename,
                tieneEncabezado: !!config.encabezadoPersonalizado,
                encabezado: config.encabezadoPersonalizado,
                numSecciones: config.secciones.length
            });

            // Generar PDF con texto nativo (await porque es async)
            const pdf = await generarPdfConTextoNativo(config);

            // Abrir en nueva ventana para impresión
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const ventana = window.open(url, '_blank');

            // Fallback: si el popup fue bloqueado, usar iframe
            if (!ventana || ventana.closed || typeof ventana.closed === 'undefined') {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
                
                iframe.onload = function() {
                    setTimeout(() => {
                        iframe.contentWindow.print();
                    }, 250);
                };
            }

            // Cerrar modal de carga
            setShowModalGenerandoPDF(false);

        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
            setShowModalGenerandoPDF(false);
        }
    };

    // 🆕 Función helper para renderizar contenido personalizado en PDF
    const renderizarContenidoPersonalizadoPDF = (contenidoPersonalizado) => {
        if (!contenidoPersonalizado) return '';

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return '';
        }

        let resultado = '';
        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                if (campo.tipo === 'checkbox') {
                    if (campo.check) {
                        resultado += `
                            <div style="margin-bottom: 8px; padding: 5px; border-left: 3px solid #28a745;">
                                <span style="font-weight: bold; color: #325e68;">${campo.nombre}:</span> 
                                <span style="color: #28a745; font-weight: bold;">✓ Sí</span>
                            </div>`;
                    }
                } else {
                    if (campo.valor && campo.valor.trim() !== '') {
                        resultado += `
                            <div style="margin-bottom: 8px; padding: 5px; border-left: 3px solid #325e68;">
                                <div style="font-weight: bold; color: #325e68; margin-bottom: 3px;">${campo.nombre}:</div>
                                <div style="color: #333; line-height: 1.4;">${campo.valor}</div>
                            </div>`;
                    }
                }
            });
        }
        return resultado;
    };

    // 🆕 Función helper para renderizar contenido personalizado para PDF (usado en evoluciones)
    const renderizarContenidoPersonalizadoParaPDF = (contenidoPersonalizado) => {
        if (!contenidoPersonalizado) {
            return "";
        }

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return "";
        }

        let resultado = "";

        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                // 🔧 OCULTAR CAMPOS VACÍOS - Solo mostrar si tiene valor
                if (campo.tipo === 'checkbox') {
                    // Para checkboxes, mostrar solo si está marcado - CON SALTO DE LÍNEA
                    if (campo.check) {
                        resultado += `<strong>${campo.nombre}:</strong> Sí<br />`;
                    }
                } else {
                    // Para otros campos, mostrar solo si tiene valor y no está vacío
                    if (campo.valor && campo.valor.trim() !== '') {
                        resultado += `<br /><label><strong>${campo.nombre}:</strong></label><br />${campo.valor}<br />`;
                    }
                }
            });
        }

        return resultado;
    };

    // 🆕 Función helper para renderizar historia clínica JSON con bandas grises
    const renderizarHistoriaClinicaJsonPDF = (historia) => {
        const nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
        const documentoCompleto = `${tipoDocumento || ''} - ${numeroDocumento || ''}`;

        // Banner + Tabla de info del paciente agrupados para evitar separación
        let bannerYTablaInfoPaciente = `
            <div class="no-page-break" style="page-break-inside: avoid !important; margin-bottom: 15px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; text-align: center; border: 1px solid #dee2e6; margin-bottom: 8px;">
                    HISTORIA CLÍNICA
                </div>
                <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 25%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${new Date(historia.fecha).toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Datos de la historia (secciones con tablas)
        let tablaDatos = '';
        try {
            const datos = typeof historia.datos === 'string' ? JSON.parse(historia.datos) : historia.datos;
            const estructura = typeof historia.plantilla_estructura === 'string' 
                ? JSON.parse(historia.plantilla_estructura) 
                : historia.plantilla_estructura;

            if (estructura && estructura.secciones && Array.isArray(estructura.secciones)) {
                estructura.secciones.forEach(seccion => {
                    let seccionTieneContenido = false;
                    let filasSeccion = '';

                    if (seccion.campos && Array.isArray(seccion.campos)) {
                        seccion.campos.forEach(campo => {
                            const valor = datos[campo.id];
                            if (valor !== undefined && valor !== null && valor !== '') {
                                seccionTieneContenido = true;

                                // Formatear valor según tipo de campo
                                let valorFormateado = valor;
                                if (campo.tipo === 'checkbox') {
                                    valorFormateado = valor ? 'Sí' : 'No';
                                } else if (campo.tipo === 'textarea') {
                                    valorFormateado = valor.replace(/\n/g, '<br>');
                                }

                                filasSeccion += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 30%; border: 1px solid #dee2e6;">${campo.label}</td>
                                        <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${valorFormateado}</td>
                                    </tr>`;
                            }
                        });
                    }

                    // Solo mostrar sección si tiene contenido
                    if (seccionTieneContenido) {
                        tablaDatos += `
                            <div class="no-page-break" style="margin-bottom: 15px; page-break-inside: avoid !important;">
                                <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; border: 1px solid #dee2e6;">${seccion.titulo}</td>
                                        </tr>
                                        ${filasSeccion}
                                    </tbody>
                                </table>
                            </div>`;
                    }
                });
            }
        } catch (error) {
            console.error('Error parseando datos de historia JSON:', error);
            tablaDatos = `<div style="color: red; padding: 8px;">Error al cargar datos de la historia</div>`;
        }

        // 4. Profesional Tratante y Firma (tabla con bandas grises)
        let tablaProfesional = '';
        if (historia.profesional) {
            tablaProfesional = `
                <div class="no-page-break" style="margin-top: 15px; page-break-inside: avoid !important;">
                    <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${historia.profesional}</td>
                            </tr>`;

            // Firma del profesional
            if (historia.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 10px; border: 1px solid #dee2e6;">
                                    <img src="${historia.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 6px; font-size: 10px; color: #6c757d;">
                                        ${historia.profesional}<br/>
                                        <strong>RM:</strong> ${historia.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${historia.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }

            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        }

        // 5. Firma del Paciente (si existe)
        let tablaFirmaPaciente = '';
        if (historia.firma_paciente) {
            tablaFirmaPaciente = `
                <div class="no-page-break" style="margin-top: 15px; page-break-inside: avoid !important;">
                    <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 30%; border: 1px solid #dee2e6;">FIRMA DEL PACIENTE</td>
                                <td style="background-color: #ffffff; padding: 10px; border: 1px solid #dee2e6;">
                                    <img src="${historia.firma_paciente}" style="max-width: 180px; max-height: 90px; display: block;" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        return `
            <div class="no-page-break" style="margin-bottom: 20px; page-break-inside: avoid !important;">
                ${bannerYTablaInfoPaciente}
                ${tablaDatos}
                ${tablaProfesional}
                ${tablaFirmaPaciente}
            </div>`;
    };

    // 🆕 Función para generar encabezado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) return '';

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return (

        <div className="hold-transition">
            <Header />
            <Aside
                activelink="patients"
                atencionPaciente={true}
                abrirEvolucion={abrirEvolucion}
                // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
                // abrirHistoriaClinica={abrirHistoriaClinica}
                abrirHistoriaClinicaJson={abrirHistoriaClinicaJson}
                abrirExamenes={abrirExamenes}
                abrirFormulas={abrirFormulas}
                abrirIncapacidades={abrirIncapacidades}
                abrirRecomendaciones={abrirRecomendaciones}
                abrirRemisiones={abrirRemisiones}
                abrirContraremisiones={abrirContraremisiones}
                abrirConsentimientos={abrirConsentimientos}
                abrirPlantillas={abrirPlantillas}
                abrirRipsFev={abrirRipsFev}
                abrirRipsSinFev={abrirRipsSinFev}
                abrirRipsConvenio={abrirRipsConvenio}
                abrirOdontograma={abrirOdontograma}
                abrirToxina={abrirToxina}
                esFacturador={esFacturador}
            />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc3"><Link to="/pacientes">Listado de Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc4">Atender Paciente</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Atención del Paciente</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">

                        {/* Botones de acceso rápido - Alineados a la derecha */}
                        <div className="row mb-3">
                            <div className="col-md-12 text-right">
                                <div className="btn-group" role="group">
                                    <div className="dropdown" style={{ display: 'inline-block', position: 'relative' }}>
                                        <button 
                                            className="btn btn-primary" 
                                            type="button" 
                                            onClick={() => setShowDropdownHistoriaClinica(!showDropdownHistoriaClinica)}
                                            style={{ marginRight: '10px', borderRadius: '4px' }}
                                        >
                                            <i className="fas fa-user-md"></i>&nbsp; Atención del Paciente <i className="fas fa-caret-down"></i>
                                        </button>
                                        {showDropdownHistoriaClinica && (
                                            <div 
                                                className="dropdown-menu show" 
                                                style={{ 
                                                    display: 'block', 
                                                    position: 'absolute', 
                                                    top: '100%', 
                                                    left: 0,
                                                    zIndex: 1000,
                                                    minWidth: '200px'
                                                }}
                                            >
                                                <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        abrirEvolucion();
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-notes-medical"></i>&nbsp; Evolución
                                                </button>
                                                {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
                                                {/* <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        abrirHistoriaClinica();
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-file-medical"></i>&nbsp; Historia Clínica (Antigua)
                                                </button> */}
                                                <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        history.push(`/historia-clinica-json?id=${pacienteId}`);
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-file-medical"></i>&nbsp; Historia Clínica
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    <Link 
                                        to={`/estado-cuenta-paciente?id=${pacienteId}`}
                                        className="btn btn-secondary"
                                        style={{ borderRadius: '4px' }}
                                    >
                                        <i className="fas fa-dollar-sign"></i>&nbsp; Cartera 
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row" id="panel-info-general">
                                            <div className="paciente-img">
                                                <div className="paciente-profile-img-container">
                                                    <img 
                                                        src={perfilimg} 
                                                        className="profile-img" 
                                                        alt="Foto del paciente"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/dist/img/user-default.jpg';
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="paciente-meta" style={{ paddingLeft: '15px' }}>
                                                <div className="row">
                                                    {/* Columna 1 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-user"></i>
                                                        <span className="micro-label">Nombres y Apellidos</span>
                                                        <span className="patient-meta-read-only">{primerNombre} {segundoNombre} {primerApellido} {segundoApellido}</span>
                                                    </div>

                                                    {/* Columna 2 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-id-card"></i>
                                                        <span className="micro-label">Tipo Documento - Documento</span>
                                                        <span className="patient-meta-read-only">{tipoDocumento} - {numeroDocumento}</span>
                                                    </div>

                                                    {/* Columna 3 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-envelope"></i>
                                                        <span className="micro-label">e-mail</span>
                                                        <span className="patient-meta-read-only">{email}</span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    {/* Columna 4 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <span className="micro-label">Celular</span>
                                                        <span className="patient-meta-read-only">{celular}</span>
                                                    </div>

                                                    {/* Columna 5 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-calendar-alt"></i>
                                                        <span className="micro-label">Edad</span>
                                                        <span className="patient-meta-read-only">{edad}</span>
                                                    </div>

                                                    {/* Columna 6 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-venus"></i>
                                                        <span className="micro-label">Sexo</span>
                                                        <span className="patient-meta-read-only">{sexoBiologico[genero]}</span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    {/* Columna 7 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-tint"></i>
                                                        <span className="micro-label">Tipo de Sangre</span>
                                                        <span className="patient-meta-read-only">{tipoSangre?.toUpperCase() || ''}</span>
                                                    </div>

                                                    {/* Columna 8 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-wheelchair"></i>
                                                        <span className="micro-label">Discapacidad</span>
                                                        <span className="patient-meta-read-only">{discapacidades[discapacidad]}</span>
                                                    </div>

                                                    {/* Columna 9 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-bullhorn"></i>
                                                        <span className="micro-label">Clasificación de Riesgo</span>
                                                        <span className="patient-meta-read-only">{clasificacionRiesgo?.toUpperCase() || ''}</span>
                                                    </div>
                                                </div>

                                                {profesionalAsignado && (
                                                    <div className="row">

                                                        <div className="col-md-4 dato-paciente">
                                                            <i className="fas fa-user-md"></i>
                                                            <span className="micro-label">Profesional Asignado</span>
                                                            <span className="patient-meta-read-only">{profesionalAsignado}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card" id="panel-info-paciente">
                                    <div className="card-header" style={{ backgroundColor: '#fff' }}>
                                        <h4 className="card-title w-100">
                                            <button
                                                type="button"
                                                className="btn btn-link d-block w-100 text-left p-0"
                                                onClick={() => setAcordeonInfoPaciente(!acordeonInfoPaciente)}
                                                aria-expanded={acordeonInfoPaciente}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    position: 'relative',
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                Información del Paciente
                                            </button>
                                        </h4>
                                    </div>
                                    <div className={`collapse ${acordeonInfoPaciente ? 'show' : ''}`} style={{ padding: '10px 20px' }}>
                                        <fieldset>
                                            <legend>Domicilio:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telefono">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefono}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="direccionPaciente">Dirección</label>
                                                        <span className="patient-meta-read-only">{direccion}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudad">Ciudad</label>
                                                        <span className="patient-meta-read-only">{ciudad} </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="paisResidencia">País</label>
                                                        <span className="patient-meta-read-only">{paisResidencia}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Datos Adicionales:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="direccionPaciente">Vinculación</label>
                                                        <span className="patient-meta-read-only">{vinculacion.toUpperCase()}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudad">EPS / Aseguradora</label>
                                                        <span className="patient-meta-read-only">{nombreEps}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="zonaDomicilio">Clasificación de Riesgo</label>
                                                        <span className="patient-meta-read-only">{clasificacionRiesgo.toUpperCase()}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telefono">Convenio / Poliza</label>
                                                        <span className="patient-meta-read-only">{convenio}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="celular">Cómo se Enteró</label>
                                                        <span className="patient-meta-read-only">{medioPublicitario}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Referido Por</label>
                                                        <span className="patient-meta-read-only">{referido}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Etnia</label>
                                                        <span className="patient-meta-read-only">{etnias[etnia]}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Identidad de Género</label>
                                                        <span className="patient-meta-read-only">{identidadesGenero[identidadGenero]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Responsable / Acompañante:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="direccionPaciente">Nombre</label>
                                                        <span className="patient-meta-read-only">{nombreResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudad">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="zonaDomicilio">Parentesco</label>
                                                        <span className="patient-meta-read-only">{parentescoResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Documento</label>
                                                        <span className="patient-meta-read-only">{documentoAcompanante}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>e-mail</label>
                                                        <span className="patient-meta-read-only">{emailAcompanante}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset style={estiloInfoMenores}>
                                            <legend>Información Adicional Para Menores de Edad:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="nombreMadre">Nombre de la Madre</label>
                                                        <span className="patient-meta-read-only">{nombreMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="docMadre">Número de Documento</label>
                                                        <span className="patient-meta-read-only">{documentoMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telMadre">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ocupacionMadre">Ocupación</label>
                                                        <span className="patient-meta-read-only">{ocupacionMadre}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="nombrePadre">Nombre del Padre</label>
                                                        <span className="patient-meta-read-only">{nombrePadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="docPadre">Número de Documento</label>
                                                        <span className="patient-meta-read-only">{documentoPadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telPadre">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoPadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ocupacionPadre">Ocupación</label>
                                                        <span className="patient-meta-read-only">{ocupacionPadre}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header" style={{ backgroundColor: '#fff' }}>
                                        <h4 className="card-title w-100">
                                            <button
                                                type="button"
                                                className="btn btn-link d-block w-100 text-left p-0"
                                                onClick={() => setAcordeonAtencion(!acordeonAtencion)}
                                                aria-expanded={acordeonAtencion}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    position: 'relative',
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                Atención de la Consulta
                                            </button>
                                        </h4>
                                    </div>
                                    <div className={`collapse ${acordeonAtencion ? 'show' : ''}`}>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* GRUPO 1: Historia Clínica Principal */}
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-primary dropdown-toggle" 
                                                            onClick={() => setShowDropdownHistoriaClinica(!showDropdownHistoriaClinica)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownHistoriaClinica}
                                                            style={{ fontSize: '14px', fontWeight: '500', padding: '12px 16px'}}
                                                        >
                                                            <i className="fas fa-notes-medical mr-2"></i>
                                                            HISTORIA CLINICA
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownHistoriaClinica ? 'show' : ''}`}>
                                                            <button className="dropdown-item" onClick={() => { abrirEvolucion(true); setShowDropdownHistoriaClinica(false); }}>
                                                                <i className="fas fa-edit mr-2 text-info"></i>
                                                                Evolucionar Historia
                                                            </button>
                                                            {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
                                                            {/* <button className="dropdown-item" onClick={() => { abrirHistoriaClinica(true); setShowDropdownHistoriaClinica(false); }}>
                                                                <i className="fas fa-file-medical-alt mr-2 text-info"></i>
                                                                {tituloHistoriaClinica}
                                                            </button> */}
                                                            <button className="dropdown-item" onClick={() => { abrirHistoriaClinicaJson(); setShowDropdownHistoriaClinica(false); }}>
                                                                <i className="fas fa-file-medical-alt mr-2 text-info"></i>
                                                                Historia Clínica
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* GRUPO 2: RIPS */}
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-primary dropdown-toggle" 
                                                            onClick={() => setShowDropdownRips(!showDropdownRips)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownRips}
                                                            style={{ fontSize: '14px', fontWeight: '500', padding: '12px 16px'}}
                                                        >
                                                            <i className="fas fa-file-invoice mr-2"></i>
                                                            RIPS
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownRips ? 'show' : ''}`}>
                                                            {esFacturador && (
                                                                <>
                                                                    <button className="dropdown-item" onClick={() => { abrirRipsFev(); setShowDropdownRips(false); }}>
                                                                        <i className="fas fa-check-circle mr-2 text-info"></i>
                                                                        Registro Rips FEV
                                                                    </button>
                                                                    <button className="dropdown-item" onClick={() => { abrirRipsConvenio(); setShowDropdownRips(false); }}>
                                                                        <i className="fas fa-handshake mr-2 text-info"></i>
                                                                        Rips Por Convenios
                                                                    </button>
                                                                </>
                                                            )}
                                                            {!esFacturador && (
                                                                <button className="dropdown-item" onClick={() => { abrirRipsSinFev(); setShowDropdownRips(false); }}>
                                                                    <i className="fas fa-file-alt mr-2 text-info"></i>
                                                                    Registro Rips Sin FEV
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* GRUPO 3: Atenciòn de Consulta */}
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-primary dropdown-toggle" 
                                                            onClick={() => setShowDropdownDocumentos(!showDropdownDocumentos)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownDocumentos}
                                                            style={{ fontSize: '14px', fontWeight: '500', padding: '12px 16px' }}
                                                        >
                                                            <i className="fas fa-file-medical mr-2"></i>
                                                            FORMULARIOS Y PLANTILLAS
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownDocumentos ? 'show' : ''}`}>
                                                            <button className="dropdown-item" onClick={() => { abrirExamenes(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-microscope mr-2 text-info"></i>
                                                                Ayudas Diagnósticas
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirConsentimientos(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-file-signature mr-2 text-info"></i>
                                                                Consentimientos
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirContraremisiones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-reply mr-2 text-info"></i>
                                                                Contraremisiones
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirFormulas(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-prescription mr-2 text-info"></i>
                                                                Fórmulas Médicas
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirIncapacidades(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-bed mr-2 text-info"></i>
                                                                Incapacidades
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirRecomendaciones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-clipboard-list mr-2 text-info"></i>
                                                                Recomendaciones
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirRemisiones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-share mr-2 text-info"></i>
                                                                Remisiones
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* GRUPO 4: Gráficos */}
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-primary dropdown-toggle" 
                                                            onClick={() => setShowDropdownGraficos(!showDropdownGraficos)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownGraficos}
                                                            style={{ fontSize: '14px', fontWeight: '500', padding: '12px 16px'}}
                                                        >
                                                            <i className="fas fa-chart-line mr-2"></i>
                                                            GRAFICOS
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownGraficos ? 'show' : ''}`}>
                                                            <button className="dropdown-item" onClick={() => { abrirOdontograma(); setShowDropdownGraficos(false); }}>
                                                                <i className="fas fa-tooth mr-2 text-info"></i>
                                                                Odontograma
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirToxina(); setShowDropdownGraficos(false); }}>
                                                                <i className="fas fa-syringe mr-2 text-info"></i>
                                                                Toxina Botulínica
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* GRUPO 5: Acciones Generales - Botón Independiente */}
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <button 
                                                        className="btn btn-success w-100" 
                                                        onClick={imprimirHistoriaConsolidada}
                                                        style={{ fontSize: '14px', fontWeight: '500', padding: '12px 16px'}}
                                                    >
                                                        <i className="fas fa-print mr-2"></i>
                                                        IMPRIMIR HISTORIA
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="card" style={{ display: 'none' }}>
                                    <div className="card-header" style={{ backgroundColor: '#fff' }}>
                                        <h4 className="card-title w-100">
                                            <button
                                                type="button"
                                                className="btn btn-link d-block w-100 text-left p-0"
                                                onClick={() => setAcordeonHistoria(!acordeonHistoria)}
                                                aria-expanded={acordeonHistoria}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    position: 'relative',
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                {tituloHistoriaClinica}
                                            </button>
                                        </h4>
                                    </div>
                                    <div className={`collapse ${acordeonHistoria ? 'show' : ''}`}>
                                        <div className="card-body">
                                            <div className="row timeline-container">
                                                {
                                                    historiasGenerales.map((historia) =>

                                                        <div className="timeline-item-container" data-toggle="modal" data-target="#modalVerHistoriaGeneral" onClick={() => consultarHistoria(historia.id)}>
                                                            <div className="timeline-fecha">{historia.fecha}</div>
                                                            <div className="timeline-punto-container">
                                                                <div className="timeline-punto"></div>
                                                            </div>
                                                            <div className="timeline-meta">
                                                                Atendido Por: {historia.profesional}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            <div className="row margen-top">
                                                <div className="col-md-12">
                                                    <a href="#" className="btn btn-primary" data-toggle="modal" data-target="#myModal"><i className="fas fa-pen"></i> {historiasGenerales.length > 0 ? 'Nueva Historia' : 'Apertura de Historia Clínica'}</a>&nbsp;

                                                    {
                                                        historiasGenerales.length > 0 &&
                                                        <>
                                                            <button className="btn btn-primary" onClick={imprimirHistoria}><i className="fas fa-download"></i> Descargar</button>
                                                            &nbsp;
                                                            <button className="btn btn-success" onClick={imprimirHistoriaConsolidada}><i className="fas fa-file-medical"></i> Imprimir Historia</button>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            idCita ? seccionEstadosCita(idCita) : null
                        }


                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} message={toastMsg} />

            <ModalOdontograma
                show={showOdontograma}
                onHide={cerrarOdontograma}
                pacienteId={paciente_id}
                paciente={{
                    primerNombre,
                    segundoNombre,
                    primerApellido,
                    segundoApellido,
                    tipoDocumento,
                    numeroDocumento
                }}
            />



            <ModalHistoriaGeneral actualizarHistorias={() => actualizarHistorias()} />

            <ModalVerHistoriaGeneral historia={historiaGeneral} />

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Clasificación de Riesgo {clasificacionRiesgo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{descripcionClasificacion}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
            {/* <Modal show={showHistoriaClinica} onHide={cerrarHistoriaClinica} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{tituloHistoriaClinica}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalHistoriaClinica cargarHistorial={cargarHistorialHistoriaClinica} cerrarModal={cerrarHistoriaClinica} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal> */}

            {/* Historia Clínica JSON ahora es una página completa en /historia-clinica-json */}

            <Modal show={showExamenes} onHide={cerrarExamenes} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Ayudas Diagnósticas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalExamenes cargarHistorial={cargarHistorialExamenes} cerrarModal={cerrarExamenes} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showFormulas} onHide={cerrarFormulas} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Fórmulas Médicas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalFormulas cargarHistorial={cargarHistorialFormulas} cerrarModal={cerrarFormulas} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showIncapacidades} onHide={cerrarIncapacidades} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Incapacidades</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalIncapacidades cargarHistorial={cargarHistorialIncapacidades} cerrarModal={cerrarIncapacidades} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showRecomendaciones} onHide={cerrarRecomendaciones} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Recomendaciones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalRecomendaciones cargarHistorial={cargarHistorialRecomendaciones} cerrarModal={cerrarRecomendaciones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showRemisiones} onHide={cerrarRemisiones} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Remisiones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalRemisiones cargarHistorial={cargarHistorialRemisiones} cerrarModal={cerrarRemisiones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showContraremisiones} onHide={cerrarContraremisiones} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Contraremisiones</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalContraremisiones cargarHistorial={cargarHistorialContraremisiones} cerrarModal={cerrarContraremisiones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showConsentimientos} onHide={cerrarConsentimientos} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Consentimientos Informados</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConsentimientos cargarHistorial={cargarHistorialConsentimientos} cerrarModal={cerrarConsentimientos} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>


            <Modal show={showRipsSinFev} onHide={cerrarRipsSinFev} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS Sin FEV</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RegistroRipsSinFev cargarHistorial={cargarHistorialRipsSinFev} cerrarModal={cerrarRipsSinFev} guardarCambios={guardarCambios} paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>

            <Modal show={showRipsFev} onHide={cerrarRipsFev} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS FEV</Modal.Title>
                </Modal.Header>
                <RegistroRipsFev
                    paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }}
                    onClose={cerrarRipsFev}
                />
            </Modal>

            <Modal show={showRipsConvenio} onHide={cerrarRipsConvenio} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS Por Convenio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RegistroRipsConvenio cargarHistorial={cargarHistorialRipsConvenio} cerrarModal={cerrarRipsConvenio} guardarCambios={guardarCambios} paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>

            {/* 🆕 Modal de carga mientras se genera el PDF */}
            <Modal show={showModalGenerandoPDF} backdrop="static" keyboard={false} centered>
                <Modal.Body className="text-center py-4">
                    <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <h5 className="mb-2">Generando historia consolidada...</h5>
                    <p className="text-muted mb-0">Por favor espere, esto puede tomar unos momentos</p>
                </Modal.Body>
            </Modal>

            <ToastContainer className="toast-exito">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                    <Toast.Body>{toastMsg}</Toast.Body>
                </Toast>
            </ToastContainer>

            <style>{`
                .btn-link::after,
                .btn-link[aria-expanded="true"]::after,
                .btn-link[aria-expanded="false"]::after {
                    display: none !important;
                }
                .card-header .btn-link {
                    position: relative;
                    background-color: transparent;
                    border: none;
                    color: #495057;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }
                .card-header .btn-link:hover {
                    color: #28a745;
                    text-decoration: none;
                    background-color: rgba(40, 167, 69, 0.1);
                }
                .card-header .btn-link[aria-expanded="true"] {
                    color: #28a745;
                    background-color: rgba(40, 167, 69, 0.1);
                }
                .card-header .btn-link::after {
                    display: none !important;
                }
                .card-header {
                    border-bottom: 1px solid #dee2e6;
                    background-color: #f8f9fa;
                }
            `}</style>

        </div>
    );
}
export default AtenderPaciente2;